import { IonIcon } from "@ionic/react";
import { bookOutline } from "ionicons/icons";
import { Link, useLocation } from "react-router-dom";
import TimedProgressBar from '@/components/TimedProgressBar';
import ProgressBar from '@/components/ProgressBar';
import { useEffect, useState } from "react";

type Lesson = { id: string; title: string };
export type Section = { title: string; items: Lesson[] };

interface ChapterLessonIndexProps {
    sections: Section[];
}

const ChapterLessonIndex: React.FC<ChapterLessonIndexProps> = ({ sections }) => {
    const location = useLocation();
    const [tocLoading, setTocLoading] = useState(false);

    useEffect(() => { setTocLoading(sections.length == 0) }, [sections])

    return (<div className="px-4 py-4 space-y-6 bg-transparent dark:bg-transparent">
        <TimedProgressBar expected_time={180} isLoading={tocLoading} title={"Reading Table of Contents"} subtitle={"Do some exercises while you wait!"} />
        {sections.map((section, section_idx) => (
        <section key={section_idx}>
            {/* Section header */}
            <div className="flex items-center gap-3 mb-4 px-4 bg-gray-100 dark:bg-gray-900 py-2 rounded-md">
            
            <IonIcon icon={bookOutline} color="primary" size="large" />
                
                <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{section.title}</h2>
            
            </div>

            {/* Lessons grid */}
            {section.items.length === 0 && (<>
                {(section_idx == 0 || (section_idx > 1 && sections[section_idx - 1].items.length > 0)) && (
                     <TimedProgressBar expected_time={360} isLoading={true} title={"Planning lessons"} subtitle={"This might take a while. Consider checking out other books while you wait ☺️"} />
                ) || (
                    <ProgressBar progress={0} isLoading={true} title={"Queued"} subtitle={"Will start processing this chapter once all previous chapters are ready."} />
                )}
                
            </>)}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            
            {section.items.map((lesson, idx) => (
                <Link
                key={idx}
                to={{
                    pathname: `${location.pathname}/${section_idx}_${idx}`
                }}
                className="block rounded-xl shadow-md transition-all p-4 bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700"
                aria-label={lesson.title}
                >
                <div className="flex items-start gap-3">
                    <div className="h-8 w-8 flex-none rounded-lg bg-blue-100 text-blue-600 dark:bg-blue-900/40 dark:text-blue-300 grid place-items-center font-semibold">
                    {lesson.title.split(' ').slice(0,2).map(w => w[0]?.toUpperCase()).join('')}
                    </div>
                    <div>
                    <div className="font-medium text-gray-900 dark:text-gray-100">{idx+1}. {lesson.title}</div>
                    </div>
                </div>
                </Link>
            ))}
            </div>
        </section>
        ))}
    </div>)
}

export default ChapterLessonIndex;